
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/hub",
      function () {
        return require("private-next-pages/training/hub.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/hub"])
      });
    }
  